import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: 'Luxury Bedouin Tents for Exclusive Events: Benefits and Features',
  description: 'Discover the perfect blend of traditional elegance and modern sophistication, and why a luxury Bedouin tent is the ultimate choice for your next exclusive event.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/luxury-bedouin-tents-exclusive-events`,
  datePublished: '2024-09-12',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['luxury Bedouin tents', 'exclusive event tents', 'traditional tent design', 'elegant event shelter', 'Bedouin tent rental'],
});

export default function LuxuryBedouinTentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}